import { REDEMPTION_LEVEL_COLORS } from './MerchantHeatmap.const';

export const getRedemptionLevelColor = (redemptionRate: number): string => {
    if (redemptionRate > 70) {
        return REDEMPTION_LEVEL_COLORS.high;
    } else if (redemptionRate >= 50) {
        return REDEMPTION_LEVEL_COLORS.medium;
    } else {
        return REDEMPTION_LEVEL_COLORS.low;
    }
};

export const getRedemptionLevelLabel = (redemptionRate: number): string => {
    if (redemptionRate > 70) {
        return 'High (>70%)';
    } else if (redemptionRate >= 50) {
        return 'Medium (50-70%)';
    } else {
        return 'Low (<50%)';
    }
};

/** Density label for map popup (based on redemption count: 60+, 30-59, <30). */
export const getDensityLabel = (redemptions: number): 'High density' | 'Medium density' | 'Low density' => {
    if (redemptions >= 60) return 'High density';
    if (redemptions >= 30) return 'Medium density';
    return 'Low density';
};

export const formatPercentage = (value: number): string => {
    return `${value.toFixed(1)}%`;
};

export const formatDateRange = (startDate?: string, endDate?: string): string => {
    if (!startDate || !endDate) return '';
    const start = new Date(startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const end = new Date(endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    return `${start} - ${end}`;
};

export {};

